import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Container from '../../containers/Modal';

export default class ModalRenderer {
    constructor(store) {
        this.store = store;
    }

    ensure(id) {
        let container = global.document.getElementById(id);

        if (!container) {
            container = global.document.createElement('div');
            container.id = id;
            container.className = 'inplayer-modal-container';
            global.document.body.appendChild(container);
        }

        if (!container) {
            throw new Error(`Can't find element with id ${id}`);
        }

        return container;
    }

    render(containerId, props = {}) {
        const container = this.ensure(containerId);

        ReactDOM.render(
            <Provider store={this.store}>
                <Container {...props} />
            </Provider>,
            container
        );
    }

    remove(containerId) {
        try {
            const container = this.ensure(containerId);
            if (container) {
                ReactDOM.unmountComponentAtNode(container);
            }
        } catch (e) {
            // do nothing if container doesn't exist
        }
    }
}



// WEBPACK FOOTER //
// ./src/ui/renderers/modal.js